import { Link } from 'react-router-dom';

interface ProductCardProps {
  id: number;
  name: string;
  category: string;
  price: number;
  originalPrice: number;
  unit: string;
  origin: string;
  brand: string;
  rating: number;
  sales: number;
  tags: string[];
  image: string;
  description: string;
}

export default function ProductCard({ id, name, price, originalPrice, unit, origin, brand, rating, sales, tags, image }: ProductCardProps) {
  const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer" data-product-shop="">
      <div className="relative overflow-hidden">
        <div className="w-full aspect-square bg-background-100">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        {discount > 0 && (
          <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md">
            -{discount}%
          </span>
        )}
        <div className="absolute top-3 right-3 flex flex-col gap-1">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="bg-background-50/90 text-foreground-700 text-xs px-2 py-0.5 rounded-md">
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">{brand}</span>
          <span className="text-xs text-foreground-400">{origin}</span>
        </div>
        <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug font-heading">
          {name}
        </h3>
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center gap-0.5">
            <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
              <i className="ri-star-fill text-xs"></i>
            </span>
            <span className="text-xs text-foreground-600 font-medium">{rating}</span>
          </div>
          <span className="text-xs text-foreground-400">已售 {sales.toLocaleString()}</span>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="text-lg font-semibold text-accent-600">¥{price}</span>
          {originalPrice > price && (
            <span className="text-xs text-foreground-400 line-through">¥{originalPrice}</span>
          )}
          <span className="text-xs text-foreground-400 ml-auto">{unit}</span>
        </div>
      </div>
    </div>
  );
}